import React from "react";
import NotificationApp from "./Notifications.js";
import {Box,Grommet,Text} from "grommet"
import { Divider } from '@mui/material';

const theme = {
    global: {
      colors: {
        brand: '#fef7e7',
        'accent-1': 'white',
        'focus': '#fef7e7',
        "my-text-color": "",
        background: 'transparent',
      },
      font: {
        family: '',
        size: '18px',
        height: '20px',
      },
      menu:{
        icons:{
          color:'white',
          },
      },
    },
  };

  /**
   * Componente che mostra tutte le notifiche dell'utente
   */
const Notification=(props)=>{
    return(
        <Grommet theme={theme}>          
            <Box height="100vh" width="100%" direction="row" style={{backgroundColor:"#transparent"}}>
                <Box width="100%" overflow="auto" aligns="center" pad="medium">
                    <Text color="#f8b20e" size="large" weight="bold" alignSelf="start">NOTIFICHE</Text>
                    <Divider/>
                    <NotificationApp notifications={props.notifications} getNotification={props.getNotification}/>
                </Box>
            </Box>
        </Grommet>
    )
}

export default Notification;